import axios from "axios";
import { getAxiosConfig } from "./axiosConfig";

// La función para obtener paciente por documento está centralizada en paciente.ts como obtenerPaciente.
// Login de paciente
export const loginPaciente = async (usuario: string, password: string): Promise<string> => {
    try {
        const urlAxioPP = localStorage.getItem("urlAxioPP") || "";
        // Lógica anterior:
        // const response = await axios.post(
        //     `Usuarios/LoginPaciente`,
        //     {
        //         nombreUsuario: usuario,
        //         password: password,
        //     },
        //     { baseURL: urlAxioPP }
        // );
        // Nueva lógica: usar siempre URL absoluta
        const baseUrl = urlAxioPP.endsWith("/") ? urlAxioPP : urlAxioPP + "/";
        const response = await axios.post(
            `${baseUrl}Usuarios/LoginPaciente`,
            {
                nombreUsuario: usuario,
                password: password,
            }
        );
        return response.data.token;
    } catch (error: any) {
        console.error('Error en loginPaciente:', error);
        throw error;
    }
};

// Actualizar contraseña del usuario
export const actualizarContrasena = async (token: string, nuevoPassword: string) => {
    try {
        const urlAxioPP = localStorage.getItem("urlAxioPP") || "";
        const configAxios = getAxiosConfig(token, urlAxioPP);
        const response = await axios.post(
            `Usuarios/ActualizarContrasenia`,
            {
                Token: token,
                NuevoPassword: nuevoPassword,
            },
            configAxios
        );
        return response;
    } catch (error) {
        console.error('Error al actualizar contraseña:', error);
        throw error;
    }
};
